import { BlobData, BlobFormat, readBlob } from './read-blob';

export async function fetchBlobAs<T extends BlobFormat>(url: string, format: T): Promise<BlobData<T>> {
    return fetch(url)
        .then(async (response) => response.blob())
        .then(async (blob) => readBlob(blob, format));
}
